import {
  EigentumanteilMasterDetailEntryMeta,
  GbeigentumService,
  GrundstueckId,
  LoadEigentumanteilSichtByGrundstueckIdResponseMeta
} from '../../../../core/gb-api';
import { Component, Input, OnChanges, OnDestroy, SimpleChanges } from '@angular/core';
import { AppConfigService } from '../../../../core/services/app-config.service';
import { TimepointCtx, TimepointService } from '../../../../core/services/timepoint.service';
import { AbstractComponent } from '../../../components/abstract-component/abstract.component';
import { catchError, map, tap } from 'rxjs/operators';
import { ListLoaderObservable } from '../../../components/list-loader/list-loader-observable';
import { ListLoader } from '../../../components/list-loader/list-loader';
import { FieldMetaData } from '../../../../core/av-api';
import { NavTarget } from '../../../components/link/link.component';
import { of } from 'rxjs';
import { EigentumanteilMasterDetailVM } from '../../../../core/services/eigentum-viewmodel.service';
import { BeschreibungTableWrapperComponent } from '../../../components/table/beschreibung-table-wrapper.component';
import { ListLoaderWrapperComponent } from '../../../components/list-loader-wrapper/list-loader-wrapper.component';
import { NgTemplateOutlet } from '@angular/common';
import { HistoryDirective } from '../../../directives/history.directive';
import { KompaktGrundstueckComponent } from '../../../kompaktdarstellung/grundstueck/kompakt-grundstueck.component';
import { KompaktTimepointComponent } from '../../../kompaktdarstellung/timepoint/kompakt-timepoint.component';
import { RechtsgrundComponent } from '../../../kompaktdarstellung/rechtsgrund/rechtsgrund.component';
import { TranslatePipe } from '@ngx-translate/core';
import { AppPermissionService } from '../../../../core/services/app-permission.service';

@Component({
  selector: 'cap-stammgrundstueck',
  templateUrl: './stammgrundstueck.component.html',
  styleUrls: ['./stammgrundstueck.component.scss'],
  imports: [
    BeschreibungTableWrapperComponent,
    ListLoaderWrapperComponent,
    NgTemplateOutlet,
    HistoryDirective,
    KompaktGrundstueckComponent,
    KompaktTimepointComponent,
    RechtsgrundComponent,
    TranslatePipe
  ]
})
export class StammgrundstueckComponent extends AbstractComponent implements OnChanges, OnDestroy {
  @Input()
  tableFullWidth: boolean = false;
  @Input()
  hasRight: boolean = true;
  listLoader: ListLoader<EigentumanteilMasterDetailEntryMeta>;
  historischeDatenSubscription;
  hasParzellenindex: boolean;
  readonly navigateTo: NavTarget = NavTarget.NAV_GRUNDSTUECK;

  constructor(
    private eigentumService: GbeigentumService,
    private timepointService: TimepointService,
    private appConfigService: AppConfigService,
    private permissionService: AppPermissionService
  ) {
    super();
  }

  _grundstueckId: GrundstueckId;

  get grundstueckId(): GrundstueckId {
    return this._grundstueckId;
  }

  @Input()
  set grundstueckId(value: GrundstueckId) {
    this._grundstueckId = value;
    if (!value) {
      return;
    }
  }

  ngOnChanges(changes: SimpleChanges) {
    if (!changes.grundstueckId.currentValue) {
      return;
    }
    this.historischeDatenSubscription = this.appConfigService.einstellungHistorischeDaten$.subscribe(() => {
      this.update();
    });
  }

  update() {
    const timepointCtx: TimepointCtx = this.timepointService.timepointCtx;
    const observable = this.eigentumService
      .loadEigentumSichtGrundstueck(
        //
        this._grundstueckId.id, //
        false, //
        'BERECHTIGT_NORMAL', //
        this.appConfigService.einstellungHistorischeDaten, //
        timepointCtx.timepointIso, //
        timepointCtx.timepointId //
      )
      .pipe(
        catchError((err) => {
          return of(<LoadEigentumanteilSichtByGrundstueckIdResponseMeta>{
            entries: [new EigentumanteilMasterDetailVM(null, err, 0, null, this.permissionService)],
            lastJunk: true
          });
        })
      )
      .pipe(
        tap((res) => this.setHasParzellenindex(res.entries)),
        map((res) => res.entries)
      );
    this.listLoader = new ListLoaderObservable<EigentumanteilMasterDetailEntryMeta>(undefined, 1, observable);
  }

  ngOnDestroy() {
    super.ngOnDestroy();
    this.historischeDatenSubscription?.unsubscribe();
  }

  private setHasParzellenindex(entries: Array<EigentumanteilMasterDetailEntryMeta>) {
    if (entries.length > 0 && entries[0].versions) {
      this.hasParzellenindex = entries[0].versions[0].mParzellenindex.access !== FieldMetaData.AccessEnum.DEACTIVATED;
    }
  }
}
